var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable, action } from 'mobx';
import { Actor } from '../../../classes/actor/Actor';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { deserialize } from '../../../utils/serializr/core/deserialize';
import { editable } from '../../../utils/mobx/decorators/editable';
import { SelectOptionUI } from './SelectOptionUI';
export class SelectOption extends Actor {
    type = 'option';
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    isSelected = false;
    shouldBeSelected = false;
    selectionDate;
    get selectTask() {
        return this.parent;
    }
    get optionIndex() {
        return this.selectTask.options.indexOf(this);
    }
    get optionNumber() {
        return this.optionIndex + 1;
    }
    get isCorrectlySelected() {
        return this.isSelected && this.shouldBeSelected;
    }
    get isWronglySelected() {
        return this.isSelected && !this.shouldBeSelected;
    }
    get isOpenToBeSelected() {
        return !this.isSelected && this.shouldBeSelected;
    }
    get isNotSelected() {
        return this.isSelected === false;
    }
    optionUI = new SelectOptionUI(this);
    selectOption({ event }) {
        this.isSelected = true;
        this.selectionDate = this.context.app.appClock.currentDate;
        if (this.isWronglySelected) {
            this.selectTask.question.answeringStepMistake.trackMistake();
        }
        if (this.isCorrectlySelected) {
            this.selectTask.question.answeringStepCorrect.trackCorrect();
        }
    }
    static fromSerialized(json = {}) {
        return deserialize(SelectOption, json);
    }
    static get serializeInfo() {
        return {
            props: {
                shouldBeSelected: true,
            },
            extends: Actor.serializeInfo,
        };
    }
}
__decorate([
    observable
], SelectOption.prototype, "isSelected", void 0);
__decorate([
    editable()
], SelectOption.prototype, "shouldBeSelected", void 0);
__decorate([
    observable.ref
], SelectOption.prototype, "selectionDate", void 0);
__decorate([
    action.bound
], SelectOption.prototype, "selectOption", null);
__decorate([
    memoize
], SelectOption, "serializeInfo", null);
